import cn from 'classnames'
import moment from 'moment'
import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { check, snooze, trash } from 'assets/icons/groove/v2'
import { doNavigateToTicket } from 'actions/navigation'
import { formatDuration } from 'util/numbers'
import { selectAgentsById } from 'selectors/agents/base'
import { selectTicketsById } from 'selectors/tickets'

const ICON_MAP = {
  closed: check,
  deleted: trash,
  opened: undefined,
  snoozed: snooze,
  unread: 'div',
}
export default function RecentConversation({
  assignee: propAssignee,
  isCurrent,
  state: propState,
  ticketId,
  title,
  updatedAt,
}) {
  const dispatch = useDispatch()
  const onClick = useCallback(() => dispatch(doNavigateToTicket(ticketId)), [
    dispatch,
    ticketId,
  ])
  const ticketsById = useSelector(selectTicketsById)
  const ticket = ticketsById[ticketId]
  const agentsById = useSelector(selectAgentsById)
  const agent = ticket && ticket.assignee && agentsById[ticket.assignee.id]
  const assignee = ticket ? agent && agent.username : propAssignee
  const ticketState =
    ticket && ticket.snoozedUntil ? 'snoozed' : ticket && ticket.state
  const state = ticket ? ticketState : propState
  const Icon = ICON_MAP[state]
  return (
    <a className={cn('ticket', { current: isCurrent })} onClick={onClick}>
      <div className="assigneeAndUpdatedAt">
        {assignee ? (
          <span className="assignee">{`@${assignee}`}</span>
        ) : (
          'Unassigned'
        )}
        {' · '}
        {formatDuration(
          moment().diff(moment(ticket ? ticket.updated_at : updatedAt))
        )}{' '}
        ago
      </div>
      <div className="titleAndState">
        <div className="title">
          {(ticket ? ticket.title : title) || <em>No Subject</em>}
        </div>
        <div className="state">{Icon && <Icon className={state} />}</div>
      </div>
    </a>
  )
}
